export default __webpack_public_path__ + "static/media/pic6.cef19163.jpg";